let preloaderEl = document.querySelector('.preloader');
let bar = document.getElementById('preloaderBar');

const setProgress = value => {

    if (!bar) return;
    const a = Math.min(1, Math.max(0, value));
    bar.style.transform = `translate3d(${(a - 1) * 100}%, 0, 0)`;

};

const clear = () => {
    if (preloaderEl && preloaderEl.parentNode)
        preloaderEl.parentNode.removeChild(preloaderEl);


    bar = null;
    preloaderEl = null;
}

module.exports.setProgress = setProgress;
module.exports.clear = clear;



// WEBPACK FOOTER //
// ./js/preloader.js